/**
 * Generated by orval v6.24.0 🍺
 * Do not edit manually.
 * Payse API
 * How to use payse API
 * OpenAPI spec version: 3.0.1
 */
import { useMutation } from "@tanstack/react-query";
import type { MutationFunction, UseMutationOptions } from "@tanstack/react-query";
import type {
  PostPosaCharge200,
  PostPosaCharge400,
  PostPosaCharge500,
  PostPosaChargeBody,
  PostPosaCheck200,
  PostPosaCheck400,
  PostPosaCheck500,
  PostPosaCheckBody,
} from ".././schemas";
import { customAxiosInstance } from "../../../configs/customAxiosInstance";
import type { ErrorType } from "../../../configs/customAxiosInstance";
import { customFormUrlEncodedFn } from "../../../configs/formUrlEncoded";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * POSAカード番号の有効・無効をチェックします。有効の場合は、カードの額面価格を返します
 * @summary POSAカード有効性確認
 */
export const postPosaCheck = (
  postPosaCheckBody: PostPosaCheckBody,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostPosaCheck200>(
    {
      url: `/posa/check`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postPosaCheckBody,
    },
    options
  );
};

export const getPostPosaCheckMutationOptions = <
  TError = ErrorType<PostPosaCheck400 | PostPosaCheck500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPosaCheck>>,
    TError,
    { data: PostPosaCheckBody },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPosaCheck>>,
  TError,
  { data: PostPosaCheckBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPosaCheck>>,
    { data: PostPosaCheckBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPosaCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPosaCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPosaCheck>>>;
export type PostPosaCheckMutationBody = PostPosaCheckBody;
export type PostPosaCheckMutationError = ErrorType<PostPosaCheck400 | PostPosaCheck500>;

/**
 * @summary POSAカード有効性確認
 */
export const usePostPosaCheck = <
  TError = ErrorType<PostPosaCheck400 | PostPosaCheck500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPosaCheck>>,
    TError,
    { data: PostPosaCheckBody },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const mutationOptions = getPostPosaCheckMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * BASE FOODポイントカードによるポイント付与を実行します
 * @summary POSAポイント付与
 */
export const postPosaCharge = (
  postPosaChargeBody: PostPosaChargeBody,
  options?: SecondParameter<typeof customAxiosInstance>
) => {
  return customAxiosInstance<PostPosaCharge200>(
    {
      url: `/posa/charge`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postPosaChargeBody,
    },
    options
  );
};

export const getPostPosaChargeMutationOptions = <
  TError = ErrorType<PostPosaCharge400 | PostPosaCharge500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPosaCharge>>,
    TError,
    { data: PostPosaChargeBody },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPosaCharge>>,
  TError,
  { data: PostPosaChargeBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPosaCharge>>,
    { data: PostPosaChargeBody }
  > = (props) => {
    const { data } = props ?? {};

    return postPosaCharge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPosaChargeMutationResult = NonNullable<Awaited<ReturnType<typeof postPosaCharge>>>;
export type PostPosaChargeMutationBody = PostPosaChargeBody;
export type PostPosaChargeMutationError = ErrorType<PostPosaCharge400 | PostPosaCharge500>;

/**
 * @summary POSAポイント付与
 */
export const usePostPosaCharge = <
  TError = ErrorType<PostPosaCharge400 | PostPosaCharge500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPosaCharge>>,
    TError,
    { data: PostPosaChargeBody },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const mutationOptions = getPostPosaChargeMutationOptions(options);

  return useMutation(mutationOptions);
};
